module.exports = "/_next/static/images/94e673d819bfbfc1d7ecc56bdeb13262-woman-playing-with-her-kids@sm.jpg";